<script lang="ts">
  export let hash: string;
  export let width: number;
  export let height: number;

  import P5 from 'p5-svelte';
  import DdLib from "@ludans/dashboard-dyslexia";

  let rendering = true;

  const sketch = (p) => {

    let qrCodeDiv;
    let slideDrawer: any;

    p.setup = () => {

      slideDrawer = DdLib.libGenDdSetup(p, width, height, hash);
      
      qrCodeDiv = p.createDiv();
      qrCodeDiv.position(0, 0);
    };

    p.draw = () => {

      DdLib.libGenDdDraw(slideDrawer);
      rendering = false;
    };

  };
</script>

<span aria-busy={rendering}>
  <P5 {sketch} />
</span>
